import type { Id } from '@hq/utils';
import { toQuery, type HttpClient } from '../client';
import type {
  ConfirmResult,
  InboundDetail,
  InboundListQuery,
  InboundPutawayRequest,
  InboundPutawayResult,
  InboundRow
} from '../types/inventoryDoc';
import type { PageResult } from '../types/result';

const BASE = '/wl/inbound';

/** 入库单：查询 + 确认（确认增加库存并写流水）。 */
export function createInboundApi(http: HttpClient) {
  return {
    list(query: InboundListQuery = {}): Promise<PageResult<InboundRow>> {
      return http.request<PageResult<InboundRow>>({ path: BASE, query: toQuery(query) });
    },

    detail(id: Id): Promise<InboundDetail> {
      return http.request<InboundDetail>({ path: `${BASE}/${id}` });
    },

    /** 确认入库：按合格数量入库，无库存行时新建。 */
    confirm(id: Id): Promise<ConfirmResult> {
      return http.request<ConfirmResult>({ path: `${BASE}/${id}/confirm`, method: 'POST' });
    },

    /** 上架登记：把入库明细指到具体货位。 */
    putaway(id: Id, body: InboundPutawayRequest): Promise<InboundPutawayResult> {
      return http.request<InboundPutawayResult>({ path: `${BASE}/${id}/putaway`, method: 'POST', body });
    }
  };
}

export type InboundApi = ReturnType<typeof createInboundApi>;
